module.exports = __webpack_public_path__ + "img/田头小站.dcc3f171.png";